interface IResponseErrorMap {
  [key: string]: string | null | undefined;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mapResponseErrors(errors: any[]): IResponseErrorMap {
  return errors.reduce<IResponseErrorMap>((result, error) => {
    if (typeof error === 'object' && typeof error.key === 'string') {
      const { key, message } = error as { key: string; message: string };

      result[key] = message;
    }

    return result;
  }, {});
}
